var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"d":"M19.17 9.17H.83a.83.83 0 000 1.66h18.34a.83.83 0 000-1.66z","fill":"#5D5D5D"}})])}
var staticRenderFns = []

export { render, staticRenderFns }